import { render, staticRenderFns } from "./P404.vue?vue&type=template&id=4c9c5b70&scoped=true&"
import script from "./P404.vue?vue&type=script&lang=js&"
export * from "./P404.vue?vue&type=script&lang=js&"
import style0 from "./P404.vue?vue&type=style&index=0&id=4c9c5b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9c5b70",
  null
  
)

export default component.exports